module.exports = __webpack_public_path__ + "img/pollution_prevention.4e692f0.svg";